import { useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import JsBarcode from "jsbarcode";
import { brl } from "@/lib/api";

export const DEFAULT_LABEL = { width: 40, height: 25, fields: ["name", "price", "barcode"] };
const formatOf = (c) => (/^\d{13}$/.test(c) ? "EAN13" : /^\d{8}$/.test(c) ? "EAN8" : "CODE128");
const fmtDay = (d) => (d ? d.slice(0, 10).split("-").reverse().join("/") : "");

export function Barcode({ code, heightMm }) {
  const ref = useRef(null);
  useEffect(() => {
    if (!ref.current || !code) return;
    const opts = { height: 34, width: 1.4, fontSize: 12, margin: 0, textMargin: 1 };
    try { JsBarcode(ref.current, code, { ...opts, format: formatOf(code) }); } catch { JsBarcode(ref.current, code, { ...opts, format: "CODE128" }); }
  }, [code]);
  return <svg ref={ref} style={{ width: "100%", height: `${heightMm}mm` }} />;
}

export const labelPrice = (p) => (Number(p.promo_price) > 0 ? p.promo_price : p.price);

export function Label({ p, cfg = DEFAULT_LABEL, store = "" }) {
  const { width: w, height: h, fields } = cfg;
  const s = Math.min(w / 40, h / 25);
  const has = (k) => fields.includes(k);
  const pt = (n) => `${(n * s).toFixed(2)}pt`;
  const meta = [has("internal_code") && p.internal_code && `Cód. ${p.internal_code}`, has("expiry") && p.expiry && `Val. ${fmtDay(p.expiry)}`].filter(Boolean).join(" · ");
  const code = has("barcode") && p.barcode;
  const extra = (has("store") && store ? 1 : 0) + (meta ? 1 : 0);
  return (
    <div className="flex flex-col justify-between overflow-hidden bg-white text-black" style={{ width: `${w}mm`, height: `${h}mm`, padding: `${1.2 * s}mm ${1.5 * s}mm` }}>
      {has("store") && store && <p className="truncate font-semibold uppercase leading-tight" style={{ fontSize: pt(5) }}>{store}</p>}
      {has("name") && <p className="line-clamp-2 font-bold leading-tight" style={{ fontSize: pt(7) }}>{p.name}</p>}
      {has("price") && <p className="font-extrabold leading-none" style={{ fontSize: pt(code ? 12 : 18) }}>{brl(labelPrice(p))}{has("unit") && <span className="font-semibold" style={{ fontSize: pt(6) }}> /{p.unit || "un"}</span>}</p>}
      {meta && <p className="truncate leading-tight" style={{ fontSize: pt(5.5) }}>{meta}</p>}
      {code ? <Barcode code={p.barcode} heightMm={h * (0.44 - 0.07 * extra)} /> : <span />}
    </div>
  );
}

export function LabelSheet({ labels, cfg, store, Item = Label }) {
  return createPortal(
    <div className="print-area hidden print:block" style={{ width: `${cfg.width}mm` }} data-testid="labels-print-area">
      <style>{`@page { size: ${cfg.width}mm ${cfg.height}mm; margin: 0; }`}</style>
      {labels.map((p, i) => <div key={i} className="ticket-page"><Item p={p} cfg={cfg} store={store} /></div>)}
    </div>,
    document.body,
  );
}
